module.exports = __webpack_public_path__ + "img/bussiness (1).e9a9cf31.svg";